// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsTwoToneSvg from "@fishx/icons-svg/es/asn/ContactsTwoTone";
import FishxIcon from '../components/FishxIcon';

var ContactsTwoTone = function ContactsTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsTwoToneSvg
  }));
};

ContactsTwoTone.displayName = 'ContactsTwoTone';
export default React.forwardRef(ContactsTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ContactsTwoTone.js
// module id = 2314
// module chunks = 0